'use client'

import { ComponentType } from 'react'
import { Schedule } from 'types'
// import PushIcon from 'public/img/ci-icons/pushnachrichten.svg';
// import KalenderIcon from 'public/img/ci-icons/kalender.svg'
import { useScheduleSearch } from '@/app/schedule-search/useSchedule'
import { ListItem } from '@/components/newSchedule/ListItem'
import { ListItemMobile } from '@/components/newSchedule/ListItemMobile'

export const List: ComponentType<{
  schedule: Schedule
  style?: 'list' | 'card'
}> = ({ schedule, style = 'card' }) => {
  const { data, error } = useScheduleSearch({ schedule })
  if (error) {
    console.error(error)
  }
  if (data.length === 0) {
    return null
  }
  const isListStyle = style === 'list'
  return (
    <div
      className={`@container/schedule ${
        isListStyle ? 'divide-y' : 'space-y-1'
      }`}
    >
      {data.map((game) => (
        <div key={game.id} className="">
          <div className={isListStyle ? '-mx-4' : ''}>
            <ListItem game={game} />
            <ListItemMobile game={game} />
          </div>
        </div>
      ))}
    </div>
  )
}

// function ScheduleSearchTableHeader() {
//   return (
//     <div className="hidden md:grid grid-cols-11 py-4 whitespace-nowrap text-sm gap-4">
//       <div className="col-span-3 flex gap-4 pl-4">
//         <div className="flex-1">Datum</div>
//         <div className="flex-1">Staffel</div>
//       </div>
//       <div className="col-span-3 text-end">Heim</div>
//       <div />
//       <div className="col-span-3">Gast</div>
//       <div className="col-span-1"></div>
//     </div>
//   )
// }
